import React from 'react';
import { usePropsContext } from 'src/hooks/usePropsContext';
import { NPI } from '../components/NPI';
import { LastName } from '../components/LastName';
import { FirstName } from '../components/FirstName';
import { State } from '../components/State';
import { City } from '../components/City';
import { TaxID } from '../components/TaxID';
import { ZipCode } from '../components/ZipCode';
import { Radius } from '../components/Radius';
import { Specialty } from '../components/Specialty';

export const PhysicianForm = () => {
  const { searchBy } = usePropsContext();

  return (
    <React.Fragment>
      <If condition={searchBy === 'npi'}>
        <NPI />
      </If>
      <If condition={searchBy === 'name_state'}>
        <LastName />
        <FirstName />
        <State />
      </If>
      <If condition={searchBy === 'state_city'}>
        <State />
        <City />
        <Specialty />
      </If>
      <If condition={searchBy === 'tax_id_number'}>
        <TaxID />
      </If>
      <If condition={searchBy === 'zip_code'}>
        <ZipCode />
        <Radius />
        <Specialty />
      </If>
    </React.Fragment>
  );
};
